module.exports = __webpack_public_path__ + "static/img/success_image.0b16ecb3.png";